import * as React from 'react';
import { Flex as FlexOriginal } from 'grid-styled';
var DEFAULT_ALIGNITEMS = 'flex-start';
var DEFAULT_FLEXDIRECTION = 'column';
export var Flex = function (props) {
    var alignItems = props.alignItems, justifyContent = props.justifyContent, flexDirection = props.flexDirection, flexWrap = props.flexWrap;
    return (React.createElement(FlexOriginal, { alignItems: alignItems ? alignItems : DEFAULT_ALIGNITEMS, flexDirection: flexDirection ? flexDirection : DEFAULT_FLEXDIRECTION, justifyContent: justifyContent, flexWrap: flexWrap }, props.children));
};
